import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/StoresForLogin'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class StoresForLoginStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "StoresForLoginStore",
			variables: false,
		})
	}
}

export async function load_StoresForLogin(params) {
  await initClient()

	const store = new StoresForLoginStore()

	await store.fetch(params)

	return {
		StoresForLogin: store,
	}
}
